import { render, staticRenderFns } from "./vpd-input.vue?vue&type=template&id=2da7482b&scoped=true"
import script from "./vpd-input.vue?vue&type=script&lang=js"
export * from "./vpd-input.vue?vue&type=script&lang=js"
import style0 from "./vpd-input.vue?vue&type=style&index=0&id=2da7482b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da7482b",
  null
  
)

export default component.exports